// Add popup listener
$(document).on('click', '.googleMapPopup', function(e)
{
	var link = $(this).attr('data-link-open'),
		inputGroup = $(this).parents('.js-google-map-input-group'),
		dims = [1200, 800],
		mujso = screen.availWidth - 60,
		mujvo = screen.availHeight - 80,
		viewWidth = Math.min(dims[0], mujso),
		viewHeight = Math.min(dims[1], mujvo),
		viewLeft = (mujso/2) - (viewWidth/2),
		viewTop = (mujvo/2 ) - (viewHeight/2)

	link += '&sourceWrapId=' + inputGroup.attr('id')
	
	win = window.open(link, "googleMapWindow", "width=" + viewWidth + ", height=" + viewHeight + ", top=" + viewTop + ", left=" + viewLeft + ", scrollbars=1, titlebar=0, toolbar=0, location=0, status=0, menubar=0")
	win.focus()

	e.preventDefault()
})

// Google map controller
window.GoogleMapController = function()
{
	// Public api
	var API = {},
		sourceDocument,
		sourceLatInput,
		sourceLngInput,
		sourceZoomInput,
		sourceWrapperId,
		map,
		defaultMarker,
		defaultLat = "49.7983584",
		defaultLng = "14.3540997",
		defaultZoom = 7,
		markersFound = [],
		markerSet = false,
		autoUpdate = true

	this.element = null
	this.dom = {	
		element: null,
		btnSave: null
	}

	API.GetTargetInputs = () =>
	{
		sourceWrapperId = "#" + getUrlParam("sourceWrapId")
		sourceDocument  = window.opener ? window.opener.document : document
		sourceLatInput	= sourceDocument.querySelector(sourceWrapperId + ' .map-lat')
		sourceLngInput	= sourceDocument.querySelector(sourceWrapperId + ' .map-lng')
		sourceZoomInput	= sourceDocument.querySelector(sourceWrapperId + ' .map-zoom')
	}

	API.AutocompleteInit = () =>
	{
		// Autocomplete
		var input = document.getElementById("google-map-address")
		var searchBox = new google.maps.places.SearchBox(input)
		map.controls[google.maps.ControlPosition.TOP_CENTER].push(input)

		// Bias the SearchBox results towards current map's viewport.
		map.addListener("bounds_changed", function() {
			searchBox.setBounds(map.getBounds());
		})

		// Listen for the event fired when the user selects a prediction and retrieve
		// more details for that place.
		searchBox.addListener("places_changed", function()
		{
			var places = searchBox.getPlaces()
			if (places.length == 0)
				return

			// Place found, enable save button
			markerSet = false
			API.BindSaveButton('.js-map-save')
			API.EnableSaveButton('.js-map-save')

			// Clear out the old markers.
			if (defaultMarker)
				defaultMarker.setMap(null)

			markersFound.forEach(function(marker) {
				marker.setMap(null)
			});
			markersFound = []

			// For each place, get the icon, name and location.
			var bounds = new google.maps.LatLngBounds()
			places.forEach(function(place)
			{
				// Show first marker only
				if (markerSet)
					return

				if (!place.geometry) {
					console.log("Returned place contains no geometry")
					return
				}

				// Create a marker for each place.	
				var marker = new google.maps.Marker({
					map: map,
					position: place.geometry.location,
					visible: true,
					zIndex: this.zIndex,
					draggable: true,
					animation: google.maps.Animation.DROP
				})

				defaultMarker = marker

				markersFound.push(marker)
				API.OnMarkerDragEnd(marker)
				markerSet = true

				document.querySelector('.googlemap-notice').classList.add('d-none')

				// Refresh source inputs
				if (autoUpdate) {
					sourceLatInput.value = place.geometry.location.lat();
					sourceLngInput.value = place.geometry.location.lng();
				}

				if (place.geometry.viewport) {
					// Only geocodes have viewport.
					bounds.union(place.geometry.viewport)
				} else {
					bounds.extend(place.geometry.location)
				}
			})

			map.fitBounds(bounds)
		})
	}

	API.Init = (_context) =>
	{
		this.dom.element = document.querySelector(_context || '.js-google-map')
		this.dom.btnSave = document.querySelector('.js-map-save')

		if (!this.dom.element)
			return

		API.GetTargetInputs()

		if (!sourceLatInput || !sourceLngInput)
			return

		// Custom map values
		let initLat = defaultLat,
			initLng = defaultLng,
			initZoom = defaultZoom

		// JSON config
		try {
			let data = JSON.parse(sourceDocument.querySelector(sourceWrapperId).getAttribute('data-map-config'))

			if (data.lat && !isNaN(parseFloat(data.lat)))
				initLat = parseFloat(data.lat)
			
			if (data.lng && !isNaN(parseFloat(data.lng)))
				initLng = parseFloat(data.lng)

			if (data.zoom && !isNaN(parseInt(data.zoom)))
				initZoom = parseInt(data.zoom)

			if (data.disableAutoUpdate) {
				autoUpdate = false
				API.BindSaveButton('.js-map-save')
			}

		} catch(error) {
			console.log(error)
		}

		// Default map values
		initLat = isNaN(parseFloat(sourceLatInput.value)) ? initLat : parseFloat(sourceLatInput.value)
		initLng = isNaN(parseFloat(sourceLngInput.value)) ? initLng : parseFloat(sourceLngInput.value)

		if (sourceZoomInput)
			initZoom = isNaN(parseInt(sourceZoomInput.value)) ? initZoom : parseInt(sourceZoomInput.value)

		// Map init
		map = new google.maps.Map(document.querySelector(".js-google-map"),
		{
			zoom: initZoom,
			center: new google.maps.LatLng(initLat, initLng),
			fullscreenControl: false,
			mapTypeControl: false,
			streetViewControl: false
		})

		// Default marker setup
		if (initLat != defaultLat || initLng != defaultLng)
		{
			defaultMarker = new google.maps.Marker({
				map: map,
				position: new google.maps.LatLng(initLat, initLng),
				visible: true,
				zIndex: this.zIndex,
				draggable: true,
				animation: google.maps.Animation.DROP
			})

			markerSet = true
			API.OnMarkerDragEnd(defaultMarker)
			API.EnableSaveButton('.js-map-save')
		} else {
			// Show notice
			document.querySelector('.googlemap-notice').classList.remove('d-none')
			map.setOptions({ draggableCursor: 'crosshair' })
		}

		// Ser marker by click on map
		google.maps.event.addListener(map, 'click', (e) =>
		{
			if (markerSet)
				return

			defaultMarker = new google.maps.Marker({
				map: map,
				position: e.latLng,
				visible: true,
				zIndex: this.zIndex,
				draggable: true,
				animation: google.maps.Animation.DROP
			})

			document.querySelector('.googlemap-notice').classList.add('d-none')

			if (autoUpdate) {
				sourceLatInput.value = e.latLng.lat()
				sourceLngInput.value = e.latLng.lng()
			} else {
				const btn = document.querySelector('.js-map-save')
				if (!btn)
					return

				btn.removeAttribute('disabled')
			}

			markerSet = true
			map.setOptions({ draggableCursor: '' })
			API.OnMarkerDragEnd(defaultMarker)
		})

		// Zoom change
		google.maps.event.addListener(map, 'zoom_changed', function()
		{
			if (!autoUpdate)
				return

			sourceZoomInput.value = parseInt(map.getZoom())
			sourceZoomInput.closest('.input-box.com').classList.add("--updated")

			setTimeout(() => {
				sourceZoomInput.closest('.input-box.com').classList.remove("--updated")
			}, 500)
		})

		// Autocomplete
		API.AutocompleteInit()

		initialized = true
	}

	// Map listeners
	API.OnMarkerDragEnd = (_marker) => google.maps.event.addListener(_marker, 'dragend', (e) =>
	{
		if (!autoUpdate)
			return

		var latInpBox = sourceLatInput.closest('.input-box.com')
		var lngInpBox = sourceLngInput.closest('.input-box.com')
		
		latInpBox && latInpBox.classList.add("--updated")
		lngInpBox.classList.add("--updated")

		sourceLatInput.value = e.latLng.lat()
		sourceLngInput.value = e.latLng.lng()

		setTimeout(() => {
			latInpBox.classList.remove("--updated")
			lngInpBox.classList.remove("--updated")
		}, 500)
	})

	API.BindSaveButton = function(_className)
	{
		const btn = document.querySelector(_className)
		if (!btn)
			return false

		if (!markerSet)
			btn.setAttribute('disabled', true)
		console.log('Binding save button')
		btn.addEventListener('click', (e) => API.Save())
	}

	API.EnableSaveButton = function(_className)
	{
		const btn = document.querySelector(_className)
		if (!btn)
			return

		btn.removeAttribute('disabled')
	}

	API.Save = () =>
	{
		if (!defaultMarker)
			return

		console.log('Save')

		sourceLatInput.value = defaultMarker.position.lat()
		sourceLngInput.value = defaultMarker.position.lng()

		if (sourceZoomInput)
			sourceZoomInput.value = map.getZoom()

		window.close()
	}

	return API
}